import { observable } from 'mobx';

import { json } from 'bz-utilities/files/types';
import history from 'bz-utilities/modules/networking/history/rr4';
import http from 'bz-utilities/modules/networking/http';

class Api {
  @observable timeStamp = new Date();

  public get(url: string, id?: any) {
    let req = http.get(url, id);
    return this.submit(req);
  }

  public post(url: string, data: any) {
    let req = http.post(url, data);
    return this.submit(req);
  }

  public put(url: string, data: any) {
    let req = http.put(url, data);
    return this.submit(req);
  }

  public del(url: string, id: any, data: any) {
    let req = http.del(url, id, data);
    return this.submit(req);
  }

  public save(url: string, data = {}) {
    let req = http.save(url, data);
    return this.submit(req);
  }

  private submit(req: any) {
    let token = sessionStorage.getItem('authToken');

    if (token) {
      req.set('Authorization', `Bearer ${token}`);
    }

    req.set('Accept', json);
    req.set('x-tm3-date', new Date().toJSON());
    let keepAlive = req.url.indexOf('keepalive') >= 0;
    let autoRefresh = req.url.indexOf('autoRefresh') >= 0;

    if (!autoRefresh && !keepAlive) {
      this.timeStamp = new Date();
    }
    return new Promise((resolve, reject) => {
      let success = (res) => {
        if (process.env.NODE_ENV === 'development' && res.headers['x-tm3-security-fail']) {
          alert(
            'DEV WARNING MODE: Security Failure on:   ' +
              req.url +
              '   [' +
              res.headers['x-tm3-security-fail'] +
              ']'
          );
        }
        resolve(res);
      };
      let error = (err) => {
        this.globalErrorHandler(err, req.url);
        reject(err);
      };
      http.submit(req).then(success, error);
    });
  }

  private globalErrorHandler(err, url) {
    if (!err || !err.response) return;
    let { status, headers } = err.response;
    if (process.env.NODE_ENV === 'development' && headers['x-tm3-security-fail']) {
      alert(
        'DEV WARNING MODE: Security Failure on: ' +
          headers['x-tm3-security-fail'] +
          '\n\nMaybe this remote call could be removed?'
      );
    }
    switch (status) {
      case 401:
        if (url === '/api/auth/credentials') {
          return;
        }
        return history.push('/login');
      case 403: // forbidden
      case 509: // location filtering missing - likely a bug
      case 417: // discipline error
        return history.push('/sorry');

      case 404:
        if (url.indexOf('/api/user/current') === 0) {
          if (window.location.pathname !== '/wrong-address') {
            return history.push('/wrong-address');
          }
        } else if (url.indexOf('/api/file') !== 0 && url.indexOf('/api/loginMode') !== 0) {
          return history.push('/notfound');
        }
        return;
      case 302:
        return (window.location = err.response.header['location']);
      default: //continue
    }
  }
}

export default new Api();
